const ExternalRedirect = ({ url }: { url: string }) => {
  window.location.assign(url);
  return null;
};

export default ExternalRedirect;
